import { Box, Typography } from "@mui/material";
import { StyledDashBoardCard } from "./dashBoardCard.styled";

type DashBoardCardProps = {
  title: string;
  amount: number;
  comparison: string;
  compareText: string;
};

export const DashBoardCard = ({
  title,
  amount,
  comparison,
  compareText
}: DashBoardCardProps) => {
  return (
    <StyledDashBoardCard>
      <Typography variant="h3" className="title">
        {title}
      </Typography>
      <Typography variant="h3" className={`amount`}>
        €{amount.toFixed(2)}
      </Typography>
      <Typography variant="h5" className={`comparison ${comparison.includes("-") && "negative"}`}>
        {comparison}
      </Typography>
      <Typography variant="body1" className="compareText">
        {compareText}
      </Typography>
    </StyledDashBoardCard>
  );
};
